import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';

const StThankYouItemWrapper = styled(Box)(({ theme }) => {
  return {
    padding: '2rem 1rem',
    borderRadius: '8px',
    margin: 'auto',
    marginTop: '3rem',
    height: 'fit-content',
    textAlign: 'center',
    [theme.breakpoints.down('md')]: {
      padding: '24px 21px',
    },
  };
});

export default StThankYouItemWrapper;
